import React from 'react';
import styled from 'styled-components';
import { SkeletonBox, SkeletonLine } from './BaseSkeleton';

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const ModalHeader = styled.div`
  padding: ${props => props.theme.spacing.lg};
  border-bottom: 1px solid ${props => props.theme.colors.border.light};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ModalContent = styled.div`
  flex: 1;
  padding: ${props => props.theme.spacing.lg};
  overflow-y: auto;
`;

const ModalFooter = styled.div`
  padding: ${props => props.theme.spacing.lg};
  border-top: 1px solid ${props => props.theme.colors.border.light};
`;

interface ModalSkeletonProps {
  showHeader?: boolean;
  showFooter?: boolean;
  children?: React.ReactNode;
}

const ModalSkeleton: React.FC<ModalSkeletonProps> = ({ 
  showHeader = true, 
  showFooter = false,
  children 
}) => {
  return (
    <ModalContainer>
      {showHeader && (
        <ModalHeader>
          <SkeletonLine $width="40%" $height="24px" />
          <SkeletonBox $width="24px" $height="24px" $borderRadius="4px" />
        </ModalHeader>
      )}
      <ModalContent>
        {children || <SkeletonLine $width="100%" $height="200px" />}
      </ModalContent>
      {showFooter && (
        <ModalFooter>
          <SkeletonBox $width="100%" $height="40px" />
        </ModalFooter>
      )}
    </ModalContainer>
  );
};

export default ModalSkeleton;
